import React, { FC } from 'react';
import LicenseInfoPage from './license-info';
import LicenseLogsPage from './license-logs-list';
import { Route, Routes } from 'react-router-dom';
import LicenseListIndex from './license-list-index';
import StructmasterLicenseLogsPage from './structmaster-licenses/structmaster-license-logs-list';

const LicensesIndex: FC = () => {
  return (
    <Routes>
      <Route path={`/*`} element={<LicenseListIndex />} />
      <Route path={`/logs`} element={<LicenseLogsPage />} />
      <Route path={`/structmaster-logs`} element={<StructmasterLicenseLogsPage />} />
      <Route path={`/:id`} element={<LicenseInfoPage />} />
    </Routes>
  );
};

export default LicensesIndex;
